import { z } from 'zod';

export const refreshTokenBodySchema = z.object({
  refresh_token: z.string(),
});

export type RefreshTokenBody = z.infer<typeof refreshTokenBodySchema>;
